import { GeneralSmallRemove } from "@wise-emotions/react-icons";
import IconWrap from "components/Icon/IconWrap";
import React from "react";
import classNames from "classnames";

import "./index.scss";

export type FilterProps = {
  title: string;
  isPressed: boolean;
  onClick: VoidFunction;
};

const Filter = (props: FilterProps) => {
  const { title, onClick, isPressed = false } = props;

  const handleOnClick = () => {
    onClick();
  };

  const classEl = classNames("filter", {
    "on-pressed": isPressed,
  });

  const icon = isPressed ? (
    <IconWrap>
      <GeneralSmallRemove />
    </IconWrap>
  ) : (
    ""
  );

  return (
    <button className={classEl} type="button" onClick={handleOnClick}>
      {title}
      {isPressed && <span className="filter__icon">{icon}</span>}
    </button>
  );
};

export default Filter;
